"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const zoid = tslib_1.__importStar(require("zoid/dist/zoid.frameworks"));
const EIDOS_BASE_URL = process.env.EIDOS_BASE_URL || 'http://localhost:5678';
const getZoidComp = () => {
    const url = `${EIDOS_BASE_URL}${window.location.pathname.replace(/^\/ads/, '')}`;
    return zoid
        .create({
        containerTemplate: function ({ uid, doc, frame, prerenderFrame }) {
            const container = doc.createElement('div');
            container.id = uid;
            container.appendChild(frame);
            container.appendChild(prerenderFrame);
            return container;
        },
        // prerenderTemplate: function containerTemplate({ doc }) {
        //   const p = doc.createElement('p');
        //   p.innerText = 'Please wait while the component loads...';
        //   return p;
        // },
        tag: 'index-widget',
        url,
    })
        .driver('react', {
        React: react_1.default,
        ReactDOM: react_dom_1.default,
    });
};
const ZoidComp = getZoidComp();
exports.AdsManager = react_1.memo(() => {
    return (react_1.default.createElement("div", { className: "ads-manager-wrapper" },
        react_1.default.createElement(ZoidComp, { onHistoryChange: route => {
                window.history.replaceState({}, '', '/ads' + route);
            } })));
}, () => true);
exports.AdsManager.displayName = 'AdsManager';
exports.default = exports.AdsManager;
//# sourceMappingURL=index.js.map